function closeCart () {
  
  cartElements = document.getElementsByClassName('theme-ajax-cart');
  cartOverlays = document.getElementsByClassName('ajax-cart__overlay');
  
  for(var i = 0; i < cartElements.length; i++) {
    cartElements[i].classList.remove('is-visible');
  }

  for(var i = 0; i < cartOverlays.length; i++) {
    cartOverlays[i].classList.remove('is-visible');
  }

}



  (function () {
    if (window.customElements.get('enr-announcement-bar')) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    class EnrBar extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.digits = 4;
        this.marqueeClocks = Array.prototype.slice.call(this.querySelectorAll('[data-enr-marquee-clock]'));
        this.unitCount = 0;

        if (isNaN(this.start) || isNaN(this.end)) {
          console.warn('[Announcement bar] Start/end time is missing or not ISO 8601 with an offset.');
          return;
        }

        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        var now = Date.now();
        var target = this.end;
        var ms = Math.max(0, target - now);
        var total = Math.floor(ms / 1000);

        var days = Math.floor(total / 86400);
        var units;
        if (days >= 1) {
          units = [
            [pad(days), 'DAYS'],
            [pad(Math.floor((total % 86400) / 3600)), 'HRS'],
            [pad(Math.floor((total % 3600) / 60)), 'MIN'],
            [pad(total % 60), 'SEC']
          ];
        } else {
          units = [
            [pad(Math.floor(total / 3600)), 'HOURS'],
            [pad(Math.floor((total % 3600) / 60)), 'MINUTES'],
            [pad(total % 60), 'SECONDS']
          ];
        }

        this.renderUnits(units);
        var text = units.map(function (u) { return u[0]; }).join(':');
        this.marqueeClocks.forEach(function (el) { el.textContent = text; });
      }

      renderUnits(units) {
        return units;
      }

        
    }

    window.customElements.define('enr-announcement-bar', EnrBar);
  })();


